// extracted by mini-css-extract-plugin
export var container = "styles-module--container--dCUMt";
export var copyText = "styles-module--copyText--Ueq3H";
export var scrollWrapper = "styles-module--scrollWrapper--vNMLq";